import React, { useState } from 'react';

import { InputV2 } from '@depop/web-ui-kit/InputV2';
import { useQueryClient } from '@tanstack/react-query';

import { ExperimentSwitcherRow } from './ExperimentSwitcherRow';
import styles from './styles.module.css';

import { RQ_PREVIEW_EXPS_CACHE } from '@/modules/ReactQuery/cacheKeys';
import {
  OPTIMIZELY_EXPERIMENTS,
  type OpzlyExperimentName,
} from '@/modules/experiments/config';
import { type CachedExperiments } from '@/modules/experiments/types';
import { useExperiments } from '@/modules/experiments/useExperiments';

export function ExperimentSwitcher() {
  const [filterTerm, setFilterTerm] = useState('');
  const client = useQueryClient();
  const rawCachedExps: CachedExperiments | undefined =
    client.getQueryData<CachedExperiments>([RQ_PREVIEW_EXPS_CACHE]);

  const allOpzlyExperimentKeys = Object.keys(
    OPTIMIZELY_EXPERIMENTS
  ) as unknown as OpzlyExperimentName[];

  const [cachedExps] = useExperiments(allOpzlyExperimentKeys, {
    deferred: true,
  });

  if (!cachedExps || !Object.keys(cachedExps).length) {
    return null;
  }

  const expsToRender = filterTerm
    ? Object.entries(cachedExps)
        .filter(([k]) => rawCachedExps?.[k])
        .filter(([k]) => k.includes(filterTerm))
    : Object.entries(cachedExps).filter(([k]) => rawCachedExps?.[k]);

  return (
    <div>
      <InputV2
        labelText="Filter experiments"
        id="adminTool__experimentSwitcher"
        onChange={(e) => setFilterTerm(e.target.value)}
        className={styles.searchInput}
      />
      <table className={styles.table}>
        <tbody>
          {expsToRender.map(([key, variant]) => (
            <ExperimentSwitcherRow
              key={key}
              name={key}
              selectedVariant={variant as string}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
